var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import { Box, Dialog, Divider, Grid, Typography } from '@mui/material';
import moment from 'moment';
import AutoCompleteDD from '../../../components/FormComponents/AutoCompleteDD';
import CustomButton from '../../../components/buttonComponent/CustomButton';
import { fetchLocations, fetchSalesReps, } from '../../../components/uiComponents/startApplicationDialog/application_lookup_service';
import { TAKEDOWN_STATUS, } from '../../../interfaces/createApplication';
import { formatCurrencyDisplay } from '../config/form_field_factories';
import { STATUS_COLOR_BY_LOC_STATUS, TAKEDOWN_DIALOG_FOOTER_SX, TAKEDOWN_DIALOG_HEADER_SX, TAKEDOWN_DIALOG_PAPER_SX, } from './ScheduleTakedownStyles';
var REQUIRED_FIELD_MESSAGE = 'This field is required';
var DATE_FORMAT = 'MM/DD/YYYY';
var NOT_PROVIDED = '--';
var formatAmount = function (amount) {
    return Number.isFinite(amount) && amount !== 0 ? formatCurrencyDisplay(amount) : NOT_PROVIDED;
};
var formatDate = function (value) {
    if (!value) {
        return NOT_PROVIDED;
    }
    var parsed = moment(value).utcOffset(0);
    return parsed.isValid() ? parsed.format(DATE_FORMAT) : NOT_PROVIDED;
};
var withStartedWith = function (options, startedWith) {
    if (!(startedWith === null || startedWith === void 0 ? void 0 : startedWith.value)) {
        return options;
    }
    var isListed = options.some(function (option) { return String(option.value) === String(startedWith.value); });
    return isListed ? options : __spreadArray([startedWith], options, true);
};
var LocDetail = function (_a) {
    var label = _a.label, value = _a.value, color = _a.color;
    return (React.createElement(Grid, { item: true, xs: 12, sm: 4 },
        React.createElement(Typography, { fontSize: "12px", color: "#6B7280" }, label),
        React.createElement(Typography, { fontSize: "14px", fontWeight: 600, color: color !== null && color !== void 0 ? color : '#111827' }, value)));
};
var CreateTakedownDialog = function (_a) {
    var _b, _c, _d, _e;
    var open = _a.open, locApplication = _a.locApplication, program = _a.program, raisedFor = _a.raisedFor, onClose = _a.onClose, onProceed = _a.onProceed;
    var startedWithDealer = React.useMemo(function () { return ({ label: raisedFor.dealerName, value: raisedFor.dealerAspireOId }); }, [raisedFor.dealerAspireOId, raisedFor.dealerName]);
    var startedWithLocation = React.useMemo(function () {
        return raisedFor.locationAspireOId
            ? {
                label: raisedFor.locationName,
                value: raisedFor.locationAspireOId,
                locationAspireOId: raisedFor.locationAspireOId,
                locationCode: raisedFor.locationCode,
            }
            : null;
    }, [raisedFor.locationAspireOId, raisedFor.locationCode, raisedFor.locationName]);
    var startedWithSalesRep = React.useMemo(function () {
        return raisedFor.salesRepId
            ? { label: raisedFor.salesRepName, value: raisedFor.salesRepId }
            : null;
    }, [raisedFor.salesRepId, raisedFor.salesRepName]);
    var _f = React.useState([]), locationOptions = _f[0], setLocationOptions = _f[1];
    var _g = React.useState([]), salesRepOptions = _g[0], setSalesRepOptions = _g[1];
    var _h = React.useState(startedWithLocation), dealerLocation = _h[0], setDealerLocation = _h[1];
    var _j = React.useState(startedWithSalesRep), salesRep = _j[0], setSalesRep = _j[1];
    var isRaisedForKnown = Boolean(raisedFor.dealerAspireOId);
    var _k = React.useState(false), isLoadingLocations = _k[0], setIsLoadingLocations = _k[1];
    var _l = React.useState(false), isLoadingSalesReps = _l[0], setIsLoadingSalesReps = _l[1];
    var _m = React.useState({}), errors = _m[0], setErrors = _m[1];
    React.useEffect(function () {
        if (!open) {
            return;
        }
        setDealerLocation(startedWithLocation);
        setSalesRep(startedWithSalesRep);
        setErrors({});
    }, [open, startedWithLocation, startedWithSalesRep]);
    React.useEffect(function () {
        if (!open || !raisedFor.dealerAspireOId) {
            return undefined;
        }
        var isCancelled = false;
        setIsLoadingLocations(true);
        fetchLocations(raisedFor.dealerAspireOId).then(function (_a) {
            var options = _a.options;
            if (!isCancelled) {
                setLocationOptions(options);
                setIsLoadingLocations(false);
            }
        });
        return function () {
            isCancelled = true;
        };
    }, [open, raisedFor.dealerAspireOId]);
    React.useEffect(function () {
        if (!open || !raisedFor.dealerAspireOId || !(dealerLocation === null || dealerLocation === void 0 ? void 0 : dealerLocation.locationAspireOId)) {
            return undefined;
        }
        var isCancelled = false;
        setIsLoadingSalesReps(true);
        fetchSalesReps(raisedFor.dealerAspireOId, dealerLocation.locationAspireOId, dealerLocation.locationCode).then(function (_a) {
            var options = _a.options;
            if (isCancelled) {
                return;
            }
            setSalesRepOptions(options);
            setSalesRep(function (previousRep) {
                if (previousRep &&
                    options.some(function (option) { return String(option.value) === String(previousRep.value); })) {
                    return previousRep;
                }
                return options.length === 1 ? options[0] : null;
            });
            setIsLoadingSalesReps(false);
        });
        return function () {
            isCancelled = true;
        };
    }, [
        dealerLocation === null || dealerLocation === void 0 ? void 0 : dealerLocation.locationAspireOId,
        dealerLocation === null || dealerLocation === void 0 ? void 0 : dealerLocation.locationCode,
        open,
        raisedFor.dealerAspireOId,
    ]);
    var visibleLocationOptions = React.useMemo(function () { return withStartedWith(locationOptions, startedWithLocation); }, [locationOptions, startedWithLocation]);
    var visibleSalesRepOptions = React.useMemo(function () { return withStartedWith(salesRepOptions, startedWithSalesRep); }, [salesRepOptions, startedWithSalesRep]);
    var handleLocationChange = React.useCallback(function (event) {
        var _a;
        setDealerLocation((_a = visibleLocationOptions.find(function (option) { return String(option.value) === event.target.value; })) !== null && _a !== void 0 ? _a : null);
        setErrors(function (previousErrors) { return (__assign(__assign({}, previousErrors), { location: '' })); });
    }, [visibleLocationOptions]);
    var handleSalesRepChange = React.useCallback(function (event) {
        var _a;
        setSalesRep((_a = visibleSalesRepOptions.find(function (option) { return String(option.value) === event.target.value; })) !== null && _a !== void 0 ? _a : null);
        setErrors(function (previousErrors) { return (__assign(__assign({}, previousErrors), { salesRep: '' })); });
    }, [visibleSalesRepOptions]);
    var handleProceed = React.useCallback(function () {
        var _a, _b, _c, _d, _e, _f, _g;
        var nextErrors = isRaisedForKnown
            ? {
                location: (dealerLocation === null || dealerLocation === void 0 ? void 0 : dealerLocation.locationAspireOId) ? '' : REQUIRED_FIELD_MESSAGE,
                salesRep: (salesRep === null || salesRep === void 0 ? void 0 : salesRep.value) ? '' : REQUIRED_FIELD_MESSAGE,
            }
            : { location: '', salesRep: '' };
        setErrors(nextErrors);
        if (Object.values(nextErrors).some(Boolean)) {
            return;
        }
        onProceed({
            dealerAspireOId: raisedFor.dealerAspireOId,
            dealerName: raisedFor.dealerName,
            locationAspireOId: (_a = dealerLocation === null || dealerLocation === void 0 ? void 0 : dealerLocation.locationAspireOId) !== null && _a !== void 0 ? _a : '',
            locationCode: (_b = dealerLocation === null || dealerLocation === void 0 ? void 0 : dealerLocation.locationCode) !== null && _b !== void 0 ? _b : '',
            locationName: String((_c = dealerLocation === null || dealerLocation === void 0 ? void 0 : dealerLocation.label) !== null && _c !== void 0 ? _c : ''),
            salesRepId: String((_d = salesRep === null || salesRep === void 0 ? void 0 : salesRep.value) !== null && _d !== void 0 ? _d : ''),
            salesRepName: String((_e = salesRep === null || salesRep === void 0 ? void 0 : salesRep.label) !== null && _e !== void 0 ? _e : ''),
            salesRepAccountAspireId: (_g = (_f = salesRepOptions.find(function (option) { return String(option.value) === String(salesRep === null || salesRep === void 0 ? void 0 : salesRep.value); })) === null || _f === void 0 ? void 0 : _f.accountAspireId) !== null && _g !== void 0 ? _g : (String(salesRep === null || salesRep === void 0 ? void 0 : salesRep.value) === raisedFor.salesRepId
                ? raisedFor.salesRepAccountAspireId
                : ''),
        });
    }, [
        dealerLocation,
        onProceed,
        raisedFor.dealerAspireOId,
        raisedFor.dealerName,
        raisedFor.salesRepAccountAspireId,
        raisedFor.salesRepId,
        salesRep,
        salesRepOptions,
    ]);
    return (React.createElement(Dialog, { open: open, onClose: onClose, maxWidth: "sm", fullWidth: true, "aria-labelledby": "create-takedown-title", PaperProps: { sx: TAKEDOWN_DIALOG_PAPER_SX } },
        React.createElement(Box, { sx: TAKEDOWN_DIALOG_HEADER_SX },
            React.createElement(Typography, { id: "create-takedown-title", fontWeight: 700, fontSize: "16px" }, "Create Takedown"),
            React.createElement(Typography, { fontSize: "13px", color: "#6B7280", mt: 0.5 }, "Request Takedown from approved LOC")),
        React.createElement(Box, { sx: { px: 3, py: 2.5 } },
            React.createElement(Typography, { fontWeight: 600, fontSize: "15px", mb: 2 }, "Application Details"),
            React.createElement(Grid, { container: true, spacing: 2, mb: 2.5 },
                React.createElement(LocDetail, { label: "Customer Name", value: (locApplication === null || locApplication === void 0 ? void 0 : locApplication.customerName) || NOT_PROVIDED }),
                React.createElement(LocDetail, { label: "Transaction Number", value: (locApplication === null || locApplication === void 0 ? void 0 : locApplication.transactionNum) || NOT_PROVIDED }),
                React.createElement(LocDetail, { label: "Approved Amount", value: formatAmount((_b = locApplication === null || locApplication === void 0 ? void 0 : locApplication.approvedAmount) !== null && _b !== void 0 ? _b : 0) }),
                React.createElement(LocDetail, { label: "Available Amount", value: formatAmount((_c = locApplication === null || locApplication === void 0 ? void 0 : locApplication.availableAmount) !== null && _c !== void 0 ? _c : 0) }),
                React.createElement(LocDetail, { label: "Expiration Date", value: formatDate((_d = locApplication === null || locApplication === void 0 ? void 0 : locApplication.expirationDate) !== null && _d !== void 0 ? _d : '') }),
                React.createElement(LocDetail, { label: "Status", value: (locApplication === null || locApplication === void 0 ? void 0 : locApplication.status) || NOT_PROVIDED, color: STATUS_COLOR_BY_LOC_STATUS[(_e = locApplication === null || locApplication === void 0 ? void 0 : locApplication.status) !== null && _e !== void 0 ? _e : TAKEDOWN_STATUS.Expired] })),
            React.createElement(Divider, { sx: { mb: 2.5 } }),
            React.createElement(Typography, { fontSize: "13px", color: "#374151", mb: 2 }, isRaisedForKnown
                ? 'Confirm the location and sales rep to start creating the take down.'
                : 'Confirm the program to start creating the take down.'),
            React.createElement(Grid, { container: true, spacing: 2 },
                React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                    React.createElement(AutoCompleteDD, { options: program ? [program] : [], displayKey: "label", valueKey: "value", label: "Program", isMandatoryField: true, disabled: true, name: "program", selectedValue: program, handleChange: function () { return undefined; }, handleBlur: function () { return undefined; } })),
                isRaisedForKnown && (React.createElement(React.Fragment, null,
                    React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                        React.createElement(AutoCompleteDD, { options: [startedWithDealer], displayKey: "label", valueKey: "value", label: "Dealership", isMandatoryField: true, disabled: true, name: "dealer", selectedValue: startedWithDealer, handleChange: function () { return undefined; }, handleBlur: function () { return undefined; } })),
                    React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                        React.createElement(AutoCompleteDD, { options: visibleLocationOptions, displayKey: "label", valueKey: "value", label: "Location", isMandatoryField: true, placeholder: "Select Location", disabled: isLoadingLocations && !visibleLocationOptions.length, name: "location", selectedValue: dealerLocation, handleChange: handleLocationChange, handleBlur: function () { return undefined; }, errorMessage: errors.location })),
                    React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                        React.createElement(AutoCompleteDD, { options: visibleSalesRepOptions, displayKey: "label", valueKey: "value", label: "Sales Rep", isMandatoryField: true, placeholder: "Assign Sales Rep", disabled: isLoadingSalesReps && !visibleSalesRepOptions.length, name: "salesRep", selectedValue: salesRep, handleChange: handleSalesRepChange, handleBlur: function () { return undefined; }, errorMessage: errors.salesRep })))))),
        React.createElement(Box, { sx: TAKEDOWN_DIALOG_FOOTER_SX },
            React.createElement(CustomButton, { variant: "secondary", MDButton: true, fullWidth: false, onClick: onClose }, "Cancel"),
            React.createElement(CustomButton, { MDButton: true, fullWidth: false, onClick: handleProceed }, "Proceed to Form"))));
};
export default CreateTakedownDialog;
